import { connect, mapProps } from '@formily/react'
import { cn } from '@/lib/utils'
import { SelectV2 } from '../ui/select-v2'

export interface SelectOption {
  label: string
  value: any
  disabled?: boolean
}

export interface FormilySelectProps {
  options?: SelectOption[]
  value?: any
  onChange?: (value: any) => void
  placeholder?: string
  className?: string
  disabled?: boolean
  width?: number | string
}

const InternalSelect = ({
  options = [],
  value,
  onChange,
  placeholder,
  className,
  disabled,
  ...props
}: FormilySelectProps) => {
  return (
    <SelectV2
      value={value}
      options={options}
      onChange={onChange}
      disabled={disabled}
      width="auto"
      {...props}
    />
  )
}

export const FormilySelectV2 = connect(
  InternalSelect,
  mapProps({
    dataSource: 'options',
    loading: true,
  }),
)
